import { alpha, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContentLoader from '../../subcomponents/ContentLoader';
import { fetchExternalConnectionSettings } from '../adminSlice';
import AdminSettingBool from '../inputs/AdminSettingBool';
import AdminSettingHidden from '../inputs/AdminSettingHidden';
import AdminSettingNumber from '../inputs/AdminSettingNumber';
import AdminSettingText from '../inputs/AdminSettingText';

export default function ExternalConnectionsTab() {
    const dispatch = useDispatch();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { externalConnections } = useSelector((state) => state.admin);

    useEffect(() => {
        dispatch(fetchExternalConnectionSettings());
    }, [dispatch]);

    return (
        <ContentLoader
            successCondition={externalConnections.status === "success"}
            errorCondition={externalConnections.status === "failed"}
            content={
                <Box sx={{ width: 1 }}>
                    <Grid container spacing={1}>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* MOLLIE */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.EXTCON_TITLE_MOLLIE}</Typography>
                            </Grid>
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"Siom_Mollie_Activate_Mollie"}
                                settingDefaultValue={externalConnections.data?.mollieActive}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_ACTIVE}
                                formText={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_ACTIVE_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"Siom_Mollie_Activate_Mollie_TestModus"}
                                settingDefaultValue={externalConnections.data?.mollieTest}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_TEST}
                                formText={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_TEST_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                disabledCondition={!externalConnections.data?.mollieActive}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"Siom_Mollie_Enable_Delay"}
                                settingDefaultValue={externalConnections.data?.mollieEnableDelay}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_SIOM_MOLLIE_DELAY}
                                formText={resourceFinal[appLanguage].admin.EXTCON_SIOM_MOLLIE_DELAY_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                disabledCondition={!externalConnections.data?.mollieActive}
                                xsSize={6}
                            />
                            <AdminSettingNumber
                                settingsType={"external"}
                                settingKey={"Siom_Mollie_Delay_Hours"}
                                settingDefaultValue={externalConnections.data?.mollieDelayHours}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_HOURS}
                                formText={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_HOURS_HTEXT}
                                disabledCondition={!externalConnections.data?.mollieActive || !externalConnections.data?.mollieEnableDelay}
                                xsSize={6}
                                minValue={1}
                            />
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"Siom_Mollie_Enable_Unsubscribe"}
                                settingDefaultValue={externalConnections.data?.mollieEnableUnsubscribe}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_UNSUB}
                                formText={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_UNSUB_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                disabledCondition={!externalConnections.data?.mollieActive}
                                xsSize={6}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"Siom_Mollie_token"}
                                settingDefaultValue={externalConnections.data?.mollieToken}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_TOKEN}
                                formText={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_TOKEN_HTEXT}
                                disabledCondition={!externalConnections.data?.mollieActive}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"Siom_enable_deelbetalingen"}
                                settingDefaultValue={externalConnections.data?.enablePartialPayments}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_PARTIAL_PAYMENTS}
                                formText={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_PARTIAL_PAYMENTS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingNumber
                                settingsType={"external"}
                                settingKey={"Siom_deelbetalingen_default_amount"}
                                settingDefaultValue={externalConnections.data?.defaultPartialPaymentAmount}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_PARTIAL_PAYMENTS_DEAFAULT_AMOUNT_HTEXT}
                                formText={resourceFinal[appLanguage].admin.EXTCON_MOLLIE_PARTIAL_PAYMENTS_DEAFAULT_AMOUNT_HTEXT}
                                xsSize={6}
                                minValue={2}
                                stepValue={1}
                            />
                        </Grid>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.secondary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* STORAGE */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.EXTCON_TITLE_STORAGE}</Typography>
                            </Grid>
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"Storage_connectionString"}
                                settingDefaultValue={externalConnections.data?.storageConnectionString}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_STORAGE_CONNECTION_STRING}
                                formText={resourceFinal[appLanguage].admin.EXTCON_STORAGE_CONNECTION_STRING_HTEXT}
                                xsSize={12}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"Storage_PublicContainerReadOnlySasToken"}
                                settingDefaultValue={externalConnections.data?.storageSasToken}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_STORAGE_SAS_TOKEN}
                                formText={resourceFinal[appLanguage].admin.EXTCON_STORAGE_SAS_TOKEN_HTEXT}
                                xsSize={12}
                            />
                            <AdminSettingText
                                settingsType={"external"}
                                settingKey={"Storage_PublicContainerPrimaryUri"}
                                settingDefaultValue={externalConnections.data?.storagePrimaryUri}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_STORAGE_PRIMARY_URI}
                                formText={resourceFinal[appLanguage].admin.EXTCON_STORAGE_PRIMARY_URI_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"external"}
                                settingKey={"Storage_ContainerName"}
                                settingDefaultValue={externalConnections.data?.storageContainerName}
                                formLabel={resourceFinal[appLanguage].admin.EXTCON_STORAGE_CONTAINER_NAME}
                                formText={resourceFinal[appLanguage].admin.EXTCON_STORAGE_CONTAINER_NAME_HTEXT}
                                xsSize={6}
                            />
                        </Grid>
                    </Grid>
                </Box>
            }
        />
    );
}